import { useState, useEffect } from 'react';
import NormalHome from './NormalHome';
import SmallHome from './SmallHome';
import MediumHome from './MediumHome';

const Home = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isMediumScreen, setIsMediumScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            // Detect if the screen width is less than 640px (Tailwind's `sm` breakpoint)
            setIsSmallScreen(width < 640);

            // Detect if the screen width is between 640px and 768px (Tailwind's `sm` and `md` breakpoints)
            setIsMediumScreen(width >= 640 && width < 1100);
        };

        // Initial check
        handleResize();

        // Add event listener for resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            {isSmallScreen ? (
                <SmallHome />
            ) : isMediumScreen ? (
                <MediumHome />
            ) : (
                <NormalHome />
            )}
        </div>
    );
};

export default Home;
